import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  HomeRounded as HomeRoundedIcon,
  GroupAddRounded as GroupAddRoundedIcon,
  AnalyticsRounded as AnalyticsRoundedIcon,
  ApartmentRounded as ApartmentRoundedIcon,
  DescriptionRounded as DescriptionRoundedIcon,
  RequestQuoteRounded as RequestQuoteRoundedIcon,
  InventoryRounded as InventoryRoundedIcon,
} from "@mui/icons-material";

// 🎨 React Icons
import {
  FaBoxOpen,
  FaStore,
  FaShoppingCart,
  FaUser,
  FaChartBar,
  FaMoneyBillWave,
} from "react-icons/fa";
import { MdHome, MdSettings } from "react-icons/md";
import { fetchPermission } from "../../Services/Services";
import SettingsIcon from "@mui/icons-material/Settings";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

export default function MenuContent({ onItemClick }) {
  const location = useLocation();
  const [activeSection, setActiveSection] = React.useState(null);
  const [activeSubSection, setActiveSubSection] = React.useState(null); // ✅ Nested ke liye
  const [adminSubSection, setAdminSubSection] = React.useState(null);
  const [purchaseEntrySection, setPurchaseEntrySection] =
    React.useState(null);
  const [permissions, setPermissions] = React.useState([]);
  const user_id = JSON.parse(localStorage.getItem("user_id")); // Still used for ID
  const roleType = localStorage.getItem("role");
  React.useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await fetchPermission(user_id);

        // Store permissions as objects with group and label
        // Expected format: [{ group: "Administrator", label: "Purchase Order" }, ...]
        // console.log(response)
        setPermissions(response || []);

      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    fetchPermissions();
  }, [roleType, user_id]);



  if (roleType !== "Admin" && permissions.length === 0) {
    return <div>Loading menu...</div>;
  }

  const handleToggle = (section) => {
    setActiveSection((prev) => (prev === section ? null : section));
  };

  const hasPermission = (group, label) => {
    if (roleType === "Admin") return true;
    return permissions.some((p) => p.group === group && p.label === label);
  };

  const isActive = (path) => location.pathname === path;

  const getMainButtonStyle = (selected) => ({
    backgroundColor: selected ? "#8080805b" : "#e3f2fd",
    color: selected ? "#000000" : "#000000",
    "&:hover": {
      backgroundColor: "#e3fdfcff",
      color: "#1565c0",
    },
    borderRadius: "10px",
    mb: 0.5,
  });

  const getSubItemStyle = (selected) => ({
    pl: 4,
    py: 0.25,
    minHeight: 30,
    backgroundColor: selected ? "#8080802d" : "transparent",
    color: selected ? "#333" : "#333",
    "&:hover": {
      backgroundColor: "#e3f2fd",
      color: "#1565c0",
    },
    borderRadius: "8px",
    mb: 0.25,
  });

  return (
    <List dense>
      {/* Home */}
      {hasPermission("Dashboard", "Dashboard") && (
        <ListItemButton
          component={Link}
          to="/dashboard/"
          onClick={() => {
            handleToggle("Home");
            onItemClick?.();
          }}
          sx={getMainButtonStyle(isActive("/dashboard/"))}
        >
          <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
            <MdHome style={{ fontSize: "24px", color: "#1976d2" }} />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItemButton>
      )}

      <Box sx={{ height: 5 }} />
      {/* Setting */}
      {(hasPermission("Settings", "Assign") ||
        hasPermission("Settings", "Expense") ||
        hasPermission("Settings", "Vendor") ||
        hasPermission("Settings", "Profiles") ||
        hasPermission("Settings", "Division") ||
        hasPermission("Settings", "Imprest A/C") ||
        hasPermission("Settings", "Adv worker") ||
        hasPermission("Settings", "Transporters") ||
        hasPermission("Settings", "Bank Accounts")) && (
          <>
            <ListItemButton
              onClick={() => handleToggle("Settings")}
              sx={getMainButtonStyle(activeSection === "Settings")}
            >
              <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
                <MdSettings style={{ fontSize: "24px", color: "#6a1b9a" }} />
              </ListItemIcon>
              <ListItemText primary="Settings" />
              {activeSection === "Settings" ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse
              in={activeSection === "Settings"}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {hasPermission("Settings", "Profiles") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/profiles"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/profiles"))}
                  >
                    <ListItemText primary="Profiles" />
                  </ListItemButton>
                )}

                {hasPermission("Settings", "Assign") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/role"
                    sx={getSubItemStyle(isActive("/dashboard/role"))}
                  >
                    <ListItemText primary="Assign" />
                  </ListItemButton>
                )}

                {hasPermission("Settings", "Division") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/division"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/division"))}
                >
                  <ListItemText primary="Division" />
                </ListItemButton>
              )}

                {hasPermission("Settings", "Creditor") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/vendor"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/vendor"))}
                  >
                    <ListItemText primary="Creditor" />
                  </ListItemButton>
                )}

                {hasPermission("Settings", "Debitor") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/Party"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/Party"))}
                  >
                    <ListItemText primary="Debtors" />
                  </ListItemButton>
                )}

                {/* {hasPermission("Settings", "Expense") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/expense"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/expense"))}
                >
                  <ListItemText primary="Expense" />
                </ListItemButton>
              )} */}

                {/* {hasPermission("Settings", "Imprest A/C") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/imprestmaster"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/imprestmaster"))}
                >
                  <ListItemText primary="Imprest A/C" />
                </ListItemButton>
              )} */}
                {/* 
              {hasPermission("Settings", "Adv worker") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/advworker"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/advworker"))}
                >
                  <ListItemText primary="Adv worker" />
                </ListItemButton>
              )} */}

                {hasPermission("Settings", "Bank Accounts") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/bank-accounts"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/bank-accounts"))}
                  >
                    <ListItemText primary="Bank Accounts" />
                  </ListItemButton>
                )}

                {/* {hasPermission("Settings", "Transporters") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/transporter"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/transporter"))}
                >
                  <ListItemText primary="Transporters" />
                </ListItemButton>
              )} */}
              </List>
            </Collapse>
          </>
        )}

      <Box sx={{ height: 5 }} />

      {/* Administrator */}
      {/* {(hasPermission("Administrator", "Purchase Order") ||
        hasPermission("Administrator", "Sale Order") ||
        hasPermission("Administrator", "Indent list") ||
        hasPermission("Administrator", "Performa Invoice") ||
        hasPermission("Administrator", "Journal Voucher") ||
        hasPermission("Administrator", "Purchase Voucher") ||
        hasPermission("Administrator", "Payment Voucher") ||
        hasPermission("Administrator", "Sales Voucher") ||
        hasPermission("Administrator", "Receipt Voucher") ||
        hasPermission("Administrator", "Contra Voucher")) && (
        <>
          <ListItemButton
            onClick={() => handleToggle("Administrator")}
            sx={getMainButtonStyle(activeSection === "Administrator")}
          >
            <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
              <ManageAccountsIcon style={{ fontSize: "23px", color: "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Administrator" />
            {activeSection === "Administrator" ? (
              <ExpandLess />
            ) : (
              <ExpandMore />
            )}
          </ListItemButton>

          <Collapse
            in={activeSection === "Administrator"}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {hasPermission("Administrator", "Purchase Order") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-po-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/pending-po-list"))}
                >
                  <ListItemText primary="Purchase Order" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Sale Order") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-so-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/pending-so-list"))}
                >
                  <ListItemText primary="Sale Order" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Indent list") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-indent-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/pending-indent-list"),
                  )}
                >
                  <ListItemText primary="Indent list" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Performa Invoice") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-pi-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/pending-pi-list"))}
                >
                  <ListItemText primary="Proforma Invoice" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Journal Voucher") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-general-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/pending-general-list"),
                  )}
                >
                  <ListItemText primary="Journal Voucher" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Purchase Voucher") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-purchase-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/pending-purchase-list"),
                  )}
                >
                  <ListItemText primary="Purchase Voucher" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Payment Voucher") && (
                <>
                  <ListItemButton
                    onClick={() => {
                      setAdminSubSection(
                        adminSubSection === "PaymentList"
                          ? null
                          : "PaymentList",
                      );
                    }}
                    sx={getSubItemStyle(adminSubSection === "PaymentList")}
                  >
                    <ListItemText
                      primary="Payment Voucher"
                      sx={{ minWidth: "110px !important", mr: 0 }}
                    />
                    {adminSubSection === "PaymentList" ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItemButton>

                  <Collapse
                    in={adminSubSection === "PaymentList"}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <ListItemButton
                        component={Link}
                        to="/dashboard/pending-payment-list-cash"
                        onClick={onItemClick}
                        sx={{
                          ...getSubItemStyle(
                            isActive("/dashboard/pending-payment-list-cash"),
                          ),
                          pl: 6,
                        }}
                      >
                        <ListItemText primary="Cash" />
                      </ListItemButton>

                      <ListItemButton
                        component={Link}
                        to="/dashboard/pending-payment-list-bank"
                        onClick={onItemClick}
                        sx={{
                          ...getSubItemStyle(
                            isActive("/dashboard/pending-payment-list-bank"),
                          ),
                          pl: 6,
                        }}
                      >
                        <ListItemText primary="Bank" />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </>
              )}

              {hasPermission("Administrator", "Sales Voucher") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-sales-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/pending-sales-list"),
                  )}
                >
                  <ListItemText primary="Sales Voucher" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Receipt Voucher") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-receipt-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/pending-receipt-list"),
                  )}
                >
                  <ListItemText primary="Receipt Voucher" />
                </ListItemButton>
              )}

              {hasPermission("Administrator", "Contra Voucher") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/pending-contra-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/pending-contra-list"),
                  )}
                >
                  <ListItemText primary="Contra Voucher" />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )} */}
      <Box sx={{ height: 5 }} />

      {/* Store (Purchase + Stock merged) */}

      {(hasPermission("Store", "Issue Note") ||
        hasPermission("Store", "Transfer") ||
        hasPermission("Store", "MTC") ||
        hasPermission("Store", "Stock Items") ||
        hasPermission("Store", "Indent") ||
        hasPermission("Store", "Sub Category") ||
        hasPermission("Store", "Category") ||
        hasPermission("Store", "Unit") ||
        hasPermission("Store", "Size") ||
        hasPermission("Store", "Stock Dashboard") ||
        hasPermission("Store", "Purchase Voucher") ||
        hasPermission("Store", "Purchase List") ||
        hasPermission("Store", "PE WithIndent") ||
        hasPermission("Store", "PE WithoutIndent") ||
        hasPermission("Store", "Purchase Order")) && (
          <>
            <ListItemButton
              onClick={() => handleToggle("Store")}
              sx={getMainButtonStyle(activeSection === "Store")}
            >
              <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
                <FaBoxOpen style={{ fontSize: "23px", color: "#ff9800" }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <>
                    <span>Store & </span>
                    <br />
                    <span>Procurement</span>
                  </>
                }
              />
              {activeSection === "Store" ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={activeSection === "Store"} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {hasPermission("Store", "Store Dashboard") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/innerdashboard"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/innerdashboard"))}
                  >
                    <ListItemText primary="Dashboard" />
                  </ListItemButton>
                )}

                {hasPermission("Store", "Category") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/category-list"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/category-list"))}
                  >
                    <ListItemText primary="Category" />
                  </ListItemButton>
                )}

                {/* {hasPermission("Store", "Sub Category") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/subcategory-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/subcategory-list"))}
                >
                  <ListItemText primary="Sub Category" />
                </ListItemButton>
              )} */}

                {hasPermission("Store", "Unit") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/unit"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/unit"))}
                  >
                    <ListItemText primary="Unit" />
                  </ListItemButton>
                )}

                {hasPermission("Store", "Size") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/size"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/size"))}
                  >
                    <ListItemText primary="Product Type" />
                  </ListItemButton>
                )}

                {hasPermission("Store", "Stock Items") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/item-list"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/item-list"))}
                  >
                    <ListItemText primary="Items" />
                  </ListItemButton>
                )}

                {/* {hasPermission("Store", "Indent") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/indent-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/indent-list"))}
                >
                  <ListItemText primary="Indent" />
                </ListItemButton>
              )} */}

                {/* {hasPermission("Store", "Purchase Order") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/powithoutindent"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/powithoutindent"))}
                >
                  <ListItemText primary="Purchase Order" />
                </ListItemButton>
              )} */}

                {/* ...................................................................... */}
                {hasPermission("Store", "Purchase Order") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/po-list"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/po-list"))}
                  >
                    <ListItemText primary="Purchase Order" />
                  </ListItemButton>
                )}


                {/* {hasPermission("Store", "Purchase Order") && (
                <>
                  <ListItemButton
                    onClick={() => {
                      setActiveSubSection(
                        activeSubSection === "PurchaseOrder"
                          ? null
                          : "PurchaseOrder",
                      );
                    }}
                    sx={getSubItemStyle(activeSubSection === "PurchaseOrder")}
                  >
                    <ListItemText primary="Purchase Order" />
                    {activeSubSection === "PurchaseOrder" ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItemButton>

                  <Collapse
                    in={activeSubSection === "PurchaseOrder"}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <ListItemButton
                        component={Link}
                        to="/dashboard/po-list"
                        onClick={onItemClick}
                        sx={{
                          ...getSubItemStyle(isActive("/dashboard/po-list")),
                          pl: 6,
                        }}
                      >
                        <ListItemText primary="Purchase List" />
                      </ListItemButton>

                      <ListItemButton
                        component={Link}
                        to="/dashboard/po-form"
                        onClick={onItemClick}
                        sx={{
                          ...getSubItemStyle(isActive("/dashboard/po-form")),
                          pl: 6,
                        }}
                      >
                        <ListItemText primary="Indent PO" />
                      </ListItemButton>

                      <ListItemButton
                        component={Link}
                        to="/dashboard/powithoutindent"
                        onClick={onItemClick}
                        sx={{
                          ...getSubItemStyle(
                            isActive("/dashboard/powithoutindent"),
                          ),
                          pl: 6,
                        }}
                      >
                        <ListItemText primary="Purchase Order" />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </>
              )} */}

                {(
                  hasPermission("Store", "Purchase Voucher") ||
                  hasPermission("Store", "Purchase List") ||
                  hasPermission("Store", "PE WithIndent") ||
                  hasPermission("Store", "PE WithoutIndent")
                ) && (
                    <>
                      <ListItemButton
                        onClick={() => {
                          setPurchaseEntrySection(
                            purchaseEntrySection === "PurchaseEntry"
                              ? null
                              : "PurchaseEntry"
                          );
                        }}
                        sx={getSubItemStyle(
                          purchaseEntrySection === "PurchaseEntry"
                        )}
                      >
                        <ListItemText primary="Purchase Entry" />

                        {purchaseEntrySection === "PurchaseEntry" ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        )}
                      </ListItemButton>

                      <Collapse
                        in={purchaseEntrySection === "PurchaseEntry"}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List component="div" disablePadding>

                          {hasPermission("Store", "Purchase List") && (
                            <ListItemButton
                              component={Link}
                              to="/dashboard/purchase-list"
                              onClick={onItemClick}
                              sx={{
                                ...getSubItemStyle(
                                  isActive("/dashboard/purchase-list")
                                ),
                                pl: 6,
                              }}
                            >
                              <ListItemText primary="Purchase List" />
                            </ListItemButton>
                          )}

                          {hasPermission("Store", "PE WithIndent") && (
                            <ListItemButton
                              component={Link}
                              to="/dashboard/pe-with-po"
                              onClick={onItemClick}
                              sx={{
                                ...getSubItemStyle(
                                  isActive("/dashboard/pe-with-po")
                                ),
                                pl: 6,
                              }}
                            >
                              <ListItemText
                                primary={
                                  <>
                                    Purchase Entry
                                    <br />
                                    Against PO
                                  </>
                                }
                              />
                            </ListItemButton>
                          )}

                          {hasPermission("Store", "PE WithoutIndent") && (
                            <ListItemButton
                              component={Link}
                              to="/dashboard/pe-without-po"
                              onClick={onItemClick}
                              sx={{
                                ...getSubItemStyle(
                                  isActive("/dashboard/pe-without-po")
                                ),
                                pl: 6,
                              }}
                            >
                                   <ListItemText
                                primary={
                                  <>
                                   Direct Purchase 
                                    <br />
                                    Entry
                                  </>
                                }
                              />
                            </ListItemButton>
                          )}

                        </List>
                      </Collapse>
                    </>
                  )}

                {hasPermission("Store", "Issue Note") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/issue-list"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/issue-list"))}
                  >
                    <ListItemText primary="Issue Note" />
                  </ListItemButton>
                )}

                {/* {hasPermission("Store", "Transfer") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/transferlist"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/transferlist"))}
                >
                  <ListItemText primary="Transfer" />
                </ListItemButton>
              )} */}
                {/* {hasPermission("Store", "MTC") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/mtc-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/mtc-list"))}
                >
                  <ListItemText primary="MTC" />
                </ListItemButton>
              )} */}
              </List>
            </Collapse>
          </>
        )}

      <Box sx={{ height: 5 }} />

      {/* Accounts */}
      {(hasPermission("Accounts", "Accounts Dashboard") ||
        hasPermission("Accounts", "Journal Voucher") ||
        hasPermission("Accounts", "Payments") ||
        hasPermission("Accounts", "Sales Voucher") ||
        hasPermission("Accounts", "Receipt") ||
        hasPermission("Accounts", "Order Inward") ||
        hasPermission("Accounts", "Sale Order") ||
        hasPermission("Accounts", "Performa Invoice") ||
        hasPermission("Accounts", "Contra Voucher")) && (
          <>
            <ListItemButton
              onClick={() => handleToggle("Accounts")}
              sx={getMainButtonStyle(activeSection === "Accounts")}
            >
              <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
                <AccountBalanceIcon
                  style={{ fontSize: "23px", color: "#f44336" }}
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <>
                    <span>  Project </span>
                    {/* <br />
                  <span>Finance</span> */}
                  </>
                }
              />
              {activeSection === "Accounts" ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse
              in={activeSection === "Accounts"}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {hasPermission("", "Account Dashboard") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/cards"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/cards"))}
                  >
                    <ListItemText primary="Dashboard" />
                  </ListItemButton>
                )}

                {hasPermission("Accounts", "Order Inward") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/saleorder"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/saleorder"))}
                  >
                    <ListItemText primary="Order Inward" />
                  </ListItemButton>
                )}

                {hasPermission("Accounts", "Sale Order") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/saleorderlist"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/saleorderlist"))}
                  >
                    <ListItemText primary="Order Inward List" />
                  </ListItemButton>
                )}

                {hasPermission("Accounts", "Proforma Invoice") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/performatable"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/"))}
                  >
                    <ListItemText primary="Proforma Invoice" />
                  </ListItemButton>
                )}

                {/* {hasPermission("Accounts", "Journal Voucher") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/general-voucher"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/general-voucher"))}
                >
                  <ListItemText primary="Journal Voucher" />
                </ListItemButton>
              )}

              {hasPermission("Accounts", "Contra Voucher") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/contra-voucher"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/contra-voucher"))}
                >
                  <ListItemText primary="Contra Voucher" />
                </ListItemButton>
              )} */}

                {/* {hasPermission("Accounts", "Payments") && (
                <>
                  <ListItemButton
                    onClick={() => {
                      setActiveSubSection(
                        activeSubSection === "Payments" ? null : "Payments",
                      );
                    }}
                    sx={getSubItemStyle(activeSubSection === "Payments")}
                  >
                    <ListItemText primary="Payment" />
                    {activeSubSection === "Payments" ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </ListItemButton>

                  <Collapse
                    in={activeSubSection === "Payments"}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <ListItemButton
                        component={Link}
                        to="/dashboard/payment-cash"
                        onClick={onItemClick}
                        sx={{
                          ...getSubItemStyle(
                            isActive("/dashboard/payment-cash"),
                          ),
                          pl: 6,
                        }}
                      >
                        <ListItemText primary="Cash" />
                      </ListItemButton>

                      <ListItemButton
                        component={Link}
                        to="/dashboard/payment-bank"
                        onClick={onItemClick}
                        sx={{
                          ...getSubItemStyle(
                            isActive("/dashboard/payment-bank"),
                          ),
                          pl: 6,
                        }}
                      >
                        <ListItemText primary="Bank" />
                      </ListItemButton>

                      <ListItemButton
                        component={Link}
                        to="/dashboard/payment-voucher-neft-rtgs"
                        onClick={onItemClick}
                        sx={{
                          ...getSubItemStyle(
                            isActive("/dashboard/payment-voucher-neft-rtgs"),
                          ),
                          pl: 6,
                        }}
                      >
                        <ListItemText primary="NEFT/RTGS" />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </>
              )} */}

                {/* {hasPermission("Accounts", "Receipt") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/receiptvoucher"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/receiptvoucher"))}
                >
                  <ListItemText primary="Receipt" />
                </ListItemButton>
              )} */}
              </List>
            </Collapse>
          </>
        )}
      <Box sx={{ height: 5 }} />

      {/* Operational Department */}
      {/* {(hasPermission("Operational Department", "Design & Drawing") ||
        hasPermission("Operational Department", "IBR Formalities") ||
      hasPermission("Operational Department","Issue MTC")) && (
        <>
          <ListItemButton
            onClick={() => handleToggle("Operational Department")}
            sx={getMainButtonStyle(activeSection === "Operational Department")}
          >
            <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
              <Diversity2Icon style={{ fontSize: "23px", color: "#f44336" }} />
            </ListItemIcon>
            <ListItemText
              primary={
                <>
                  <span>Operational </span>
                  <br />
                  <span>Department</span>
                </>
              }
            />
            {activeSection === "Operational Department" ? (
              <ExpandLess />
            ) : (
              <ExpandMore />
            )}
          </ListItemButton>

          <Collapse
            in={activeSection === "Operational Department"}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {hasPermission("Operational Department", "Design & Drawing") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/design-and-drawing"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/design-and-drawing"),
                  )}
                >
                  <ListItemText primary="Design & Drawing" />
                </ListItemButton>
              )}

              {hasPermission("Operational Department", "IBR Formalities") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/ibr-formalities"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/ibr-formalities"))}
                >
                  <ListItemText primary="IBR Formalities" />
                </ListItemButton>
              )}

              {hasPermission("Operational Department", "Issue MTC") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/issue-mtc-list"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/issue-mtc-list"))}
                >
                  <ListItemText primary="Issue MTC" />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )}
      <Box sx={{ height: 5 }} />*/}

      {(hasPermission("Sales & Marketing", "Enquiry") ||
        hasPermission("Sales & Marketing", "Quotation") ||
        hasPermission("Sales & Marketing", "Feedback")) && (
          <>
            <ListItemButton
              onClick={() => handleToggle("Sales & Marketing")}
              sx={getMainButtonStyle(activeSection === "Sales & Marketing")}
            >
              <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
                <FaUser style={{ fontSize: "21px", color: "#9c27b0" }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <>
                    <span>Sales & </span>
                    <br />
                    <span>Marketing</span>
                  </>
                }
              />
              {activeSection === "Sales & Marketing" ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </ListItemButton>

            <Collapse
              in={activeSection === "Sales & Marketing"}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {hasPermission("Sales & Marketing", "Enquiry") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/Enquiry"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/Enquiry"))}
                  >
                    <ListItemText primary="Enquiry" />
                  </ListItemButton>
                )}

                {hasPermission("Sales & Marketing", "Quotation") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/quotation"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/quotation"))}
                  >
                    <ListItemText primary="Quotation" />
                  </ListItemButton>
                )}

                {hasPermission("Sales & Marketing", "Feedback") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/client"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/client"))}
                  >
                    <ListItemText primary="Feedback" />
                  </ListItemButton>
                )}
              </List>
            </Collapse>
          </>
        )}

      <Box sx={{ height: 5 }} />

      {/* Reports */}
      {/* {(hasPermission("Reports", " Accounts Summary") ||
        hasPermission("Reports", "Sales List") ||
        hasPermission("Reports", "Transfer History") ||
        hasPermission("Reports", "Proforma Invoice") ||
        hasPermission("Reports", "Journal Vch. Report") ||
        hasPermission("Reports", "Purchase Voucher Rpt") ||
        hasPermission("Reports", "Purchase Report") ||
        hasPermission("Reports", "Indent Report") ||
        hasPermission("Reports", "Cash Ledger") ||
        hasPermission("Reports", "Bank Ledger") ||
        hasPermission("Reports", "Ledger Book") ||
        hasPermission("Reports", "Sale Order") ||
        hasPermission("Reports", "Daily Payment")) && (
        <>
          <ListItemButton
            onClick={() => handleToggle("Reports")}
            sx={getMainButtonStyle(activeSection === "Reports")}
          >
            <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
              <FaChartBar style={{ fontSize: "23px", color: "#ff9800" }} />
            </ListItemIcon>
            <ListItemText primary="Reports" />
            {activeSection === "Reports" ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse
            in={activeSection === "Reports"}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" disablePadding>
              {hasPermission("Reports", " Accounts Summary") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/projectsummary"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/projectsummary"))}
                >
                  <ListItemText primary=" Accounts Summary" />
                </ListItemButton>
              )}

              {hasPermission("Reports", "Cash Ledger") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/cash-ledger"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/cash-ledger"))}
                >
                  <ListItemText primary="Cash Ledger" />
                </ListItemButton>
              )}

              {hasPermission("Reports", "Bank Ledger") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/bank-ledger"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/bank-ledger"))}
                >
                  <ListItemText primary="Bank Ledger" />
                </ListItemButton>
              )}

              {hasPermission("Reports", "Ledger Book") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/ledger-book"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/ledger-book"))}
                >
                  <ListItemText primary="Ledger Book" />
                </ListItemButton>
              )}

              {hasPermission("Reports", "Journal Vch. Report") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/journal-voucher-by-division"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/journal-voucher-by-division"),
                  )}
                >
                  <ListItemText primary="Journal Voucher" />
                </ListItemButton>
              )}

              {hasPermission("Reports", "Sale Order") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/sale-order-by-date"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/sale-order-by-date"),
                  )}
                >
                  <ListItemText primary="Sale Order" />
                </ListItemButton>
              )}

              {hasPermission("Reports", "Daily Payment") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/daily-payment"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/daily-payment"))}
                >
                  <ListItemText primary="Daily Payment" />
                </ListItemButton>
              )}

              {hasPermission("Reports", "Proforma Invoice") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/performa-list-bydate"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/performa-list-bydate"),
                  )}
                >
                  <ListItemText primary="Proforma Invoice" />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )} */}
      <Box sx={{ height: 5 }} />

      {/* Stock Report*/}

      {(
        hasPermission("Stock Reports", "Stock Summary") ||
        hasPermission("Stock Reports", " Accounts Summary") ||
        hasPermission("Stock Reports", "Stock Summary") ||
        hasPermission("Stock Reports", "Material Inward") ||
        hasPermission("Stock Reports", "Stock Ladger") ||
        hasPermission("Stock Reports", "Material Issue") ||
        hasPermission("Stock Reports", "Division wise material Issue Note") ||
        hasPermission("Stock Reports", "Value of Closing Stock") ||
        hasPermission("Stock Reports", "Fast and slow moving items") ||
        hasPermission("Stock Reports", "Pending GRN") ||
        hasPermission("Stock Reports", "Item Wise Consumption") ||
        hasPermission("Stock Reports", "Indent Report") ||
        hasPermission("Stock Reports", "PO Report") ||
        hasPermission("Stock Reports", "Purchase Voucher-PO")) && (
          <>
            <ListItemButton
              onClick={() => handleToggle("Stock Reports")}
              sx={getMainButtonStyle(activeSection === "Stock Reports")}
            >
              <ListItemIcon sx={{ minWidth: 40, mr: 0 }}>
                <FaChartBar style={{ fontSize: "23px", color: "green" }} />
              </ListItemIcon>
              <ListItemText primary="Stock Reports" />
              {activeSection === "Stock Reports" ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </ListItemButton>

            <Collapse
              in={activeSection === "Stock Reports"}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {hasPermission("Stock Reports", " Accounts Summary") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/projectsummary"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/projectsummary"))}
                  >
                    <ListItemText primary=" Project Summary" />
                  </ListItemButton>
                )}
                {hasPermission("Stock Reports", "Stock Summary") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/stock-summary"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/stock-summary"))}
                  >
                    <ListItemText primary="Stock Summary" />
                  </ListItemButton>
                )}

                {hasPermission("Stock Reports", "Stock Ladger") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/stock-ledger"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/stock-ledger"))}
                  >
                    <ListItemText primary="Stock Ladger" />
                  </ListItemButton>
                )}

                {hasPermission("Stock Reports", "Material Inward") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/material-inward-register"
                    onClick={onItemClick}
                    sx={getSubItemStyle(
                      isActive("/dashboard/material-inward-register"),
                    )}
                  >
                    <ListItemText primary="Material Inward" />
                  </ListItemButton>
                )}

                {hasPermission("Stock Reports", "Material Issue") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/material-issue-register"
                    onClick={onItemClick}
                    sx={getSubItemStyle(
                      isActive("/dashboard/material-issue-register"),
                    )}
                  >
                    <ListItemText primary="Material Issue" />
                  </ListItemButton>
                )}

                {/* {hasPermission(
                "Stock Reports",
                "Division wise material Issue Note",
              ) && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/department-wise-material-usage"
                  onClick={onItemClick}
                  sx={getSubItemStyle(
                    isActive("/dashboard/department-wise-material-usage"),
                  )}
                >
                  <ListItemText
                    primary={
                      <>
                        <span>Division Wise Material</span>
                        <br />
                        <span>Issue Note</span>
                      </>
                    }
                  />
                </ListItemButton>
              )} */}

                {hasPermission("Stock Reports", "Value of Closing Stock") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/value-of-closing-stock"
                    onClick={onItemClick}
                    sx={getSubItemStyle(
                      isActive("/dashboard/value-of-closing-stock"),
                    )}
                  >
                    <ListItemText primary="Value of Closing Stock" />
                  </ListItemButton>
                )}

                {hasPermission("Stock Reports", "Item Wise Consumption") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/item-wise-consumption-report"
                    onClick={onItemClick}
                    sx={getSubItemStyle(
                      isActive("/dashboard/item-wise-consumption-report"),
                    )}
                  >
                    <ListItemText primary="Item Wise Consumption" />
                  </ListItemButton>
                )}

                {hasPermission("Stock Reports", "Pending GRN") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/grn-pending-for-approval"
                    onClick={onItemClick}
                    sx={getSubItemStyle(
                      isActive("/dashboard/grn-pending-for-approval"),
                    )}
                  >
                    <ListItemText primary="Pending GRN" />
                  </ListItemButton>
                )}

                {/* {hasPermission("Stock Reports", "Fast and slow moving items") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/fast-slow-moving-items"
                    onClick={onItemClick}
                    sx={getSubItemStyle(
                      isActive("/dashboard/fast-slow-moving-items"),
                    )}
                  >
                    <ListItemText primary="Fast Slow Moving Items" />
                  </ListItemButton>
                )} */}

                {/* {hasPermission("Stock Reports", "Indent Status") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/indent-status"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/indent-status"))}
                >
                  <ListItemText primary="Indent Status" />
                </ListItemButton>
              )} */}

                {hasPermission("Stock Reports", "PO Status") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/po-status"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/po-status"))}
                  >
                    <ListItemText primary="PO Status" />
                  </ListItemButton>
                )}
                {/* {hasPermission("Stock Reports", "PO Indent") && (
                <ListItemButton
                  component={Link}
                  to="/dashboard/po-indent"
                  onClick={onItemClick}
                  sx={getSubItemStyle(isActive("/dashboard/po-indent"))}
                >
                  <ListItemText primary="PO Indent" />
                </ListItemButton>
              )} */}
                {hasPermission("Stock Reports", "Purchase Voucher PO") && (
                  <ListItemButton
                    component={Link}
                    to="/dashboard/purchase-voucher-po"
                    onClick={onItemClick}
                    sx={getSubItemStyle(isActive("/dashboard/purchase-voucher-po"))}
                  >
                    <ListItemText primary="Purchase Voucher PO" />
                  </ListItemButton>
                )}
              </List>
            </Collapse>
          </>
        )}
    </List>
  );
}
